import { Typography } from "@material-ui/core";
import { UserAccessRoleDto } from "Api/Api";
import {
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
} from "Components/Shared/Icons";
import { StyledFlex } from "Components/Shared/StyledComponents";
import * as React from "react";
import styled from "styled-components";
import { Resources, useResource } from "Translations/Resources";
import { useDispatch } from "react-redux";
import { setDisableRedirect } from "State/App/AppReducer";
import { useState } from "react";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

type Props = {
  roles: UserAccessRoleDto[];
  setRoles: (val: UserAccessRoleDto[]) => void;
};

const StyledWrapper = styled.div`
  margin-top: ${props => props.theme.spacing(3)}px;
  margin-bottom: ${props => props.theme.spacing(5)}px;
  width: 100%;
  max-width: 400px;
  & > p {
    font-weight: 300;
    color: ${props => props.theme.palette.secondary.main};
    margin-bottom: ${props => props.theme.spacing(2)}px;
  }

  ${props => props.theme.breakpoints.down("xs")} {
    max-width: 100%;
  }
`;

const StyledRole = styled.div`
  display: flex;
  margin-bottom: ${props => props.theme.spacing(1.25)}px;
`;

const StyledRoleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  p {
    text-align: left;
    padding-left: 10px;
  }

  .tooltip-icon {
    width: 20px;
    margin-left: 5px;
  }
`;

const StyledRights = styled.ul`
  margin-top: -5px;
  margin-bottom: 5px;
`;

export const UserAccessRoles: React.FunctionComponent<Props> = props => {
  const { t } = useResource();
  const dispatch = useDispatch();
  const { roles, setRoles } = props;

  const handleClick = (role: UserAccessRoleDto) => {
    const updatedRoles = roles.map(e => {
      if (e.accessRoleID === role.accessRoleID) {
        return { ...e, hasRole: !role.hasRole };
      }
      return e;
    });
    setRoles(updatedRoles);
    dispatch(setDisableRedirect(true));
  };

  return (
    <StyledWrapper>
      <div className={"form-title"}>
        {t(Resources.Users.Detail.AccessRoles.Title)}
      </div>

      <div>
        {roles
          ?.slice()
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(e => (
            <UserAccessRoleItem role={e} onCheckboxClick={handleClick} />
          ))}
      </div>
    </StyledWrapper>
  );
};

type ItemProps = {
  role: UserAccessRoleDto;
  onCheckboxClick: (role: UserAccessRoleDto) => void;
};

const UserAccessRoleItem: React.FunctionComponent<ItemProps> = props => {
  const { role } = props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <StyledRole key={role.accessRoleID}>
        <StyledRoleWrapper>
          <StyledFlex onClick={() => props.onCheckboxClick(role)}>
            {role.hasRole ? <CheckboxCheckedIcon /> : <CheckboxUncheckedIcon />}
          </StyledFlex>
          <Typography onClick={() => props.onCheckboxClick(role)}>
            {role.name}
          </Typography>
          {isOpen ? (
            <ArrowDropUpIcon
              className="tooltip-icon"
              onClick={() => setIsOpen(!isOpen)}
            />
          ) : (
            <ArrowDropDownIcon
              className="tooltip-icon"
              onClick={() => setIsOpen(!isOpen)}
            />
          )}
        </StyledRoleWrapper>
      </StyledRole>
      {isOpen && (
        <StyledRights>
          {role.accessRights
            .slice()
            .sort((a, b) => a.code.localeCompare(b.code))
            .map(right => (
              <li>{right.code}</li>
            ))}
        </StyledRights>
      )}
    </>
  );
};
